import { render, staticRenderFns } from "./popUp.vue?vue&type=template&id=5a09cb3a&scoped=true&lang=pug&"
import script from "./popUp.vue?vue&type=script&lang=js&"
export * from "./popUp.vue?vue&type=script&lang=js&"
import style0 from "./popUp.vue?vue&type=style&index=0&id=5a09cb3a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a09cb3a",
  null
  
)

export default component.exports